import BottomSheet from 'components/bottom-sheet';
import Button from 'components/button';
import styles from './styles.module.scss';
import { SpringEvent } from 'react-spring-bottom-sheet/dist/types';
import Header from 'components/header';

interface IBottomSheetConfirm {
  isOpen: boolean;
  onDismiss: () => void;
  onAgree: () => void;
  onSpringEnd?: (event: SpringEvent) => void;
  title: string;
  isLoading: boolean;
  nameAction?: string;
  text?: string;
  withoutCancel?: boolean;
}

const BASE_NAME_ACTION = 'удалить';

const BottomSheetConfirm = ({
  isOpen,
  title,
  withoutCancel,
  isLoading,
  text,
  nameAction,
  onAgree,
  onDismiss,
  onSpringEnd,
}: IBottomSheetConfirm) => {
  return (
    <BottomSheet
      open={isOpen}
      header={<Header text={title} />}
      onSpringEnd={onSpringEnd}
      onDismiss={onDismiss}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight]}
      blocking={true}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.containerBottomSheet}>
        {text && <div className={styles.text}>{text}</div>}
        <div className={styles.btnFlex}>
          {!withoutCancel && <Button variant='gray' label='отмена' onClick={onDismiss} />}
          <Button
            label={nameAction ? nameAction : BASE_NAME_ACTION}
            loading={isLoading}
            onClick={onAgree}
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default BottomSheetConfirm;
